import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: [],
  },
  mutations: {
    SET_USER(state, userInfo) {
      state.user = userInfo;
    },
  },
  actions: {
    async setUser({ commit }) {
      let dga_domain = this._vm.$dga_domain
      let dga_token = localStorage.getItem("dga_token");
      let dga_id_token = localStorage.getItem("dga_id_token");
      let ssj_token = localStorage.getItem("ssj_token");
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: dga_domain + "/connect/userinfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + dga_token,
        },
      };

      return new Promise((resolve, reject) => {
        axios.request(config).then(
          (response) => {
            response.data.id_token = dga_id_token;
            response.data.ssj_token = ssj_token;
            commit("SET_USER", response.data);
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
  },
  modules: {},
  getters: {
    token(state) {
      return state.token;
    },
  },
});
